module.exports = __webpack_public_path__ + "static/media/tip-active.bcc40a3c.svg";